// extracted by mini-css-extract-plugin
export var carrierTab = "_5j-0";
export var carrierTabActive = "_5j-1 _5j-0";
export var carrierTabInactive = "_5j-2 _5j-0";
export var carrierTabLabel = "_5j-3";
export var carrierTabLabelActive = "_5j-4 _5j-3";
export var carrierTabLabelInactive = "_5j-5 _5j-3";
export var carrierTabPercentage = "_5j-6";
export var carrierTabPercentageActive = "_5j-7 _5j-6";
export var carrierTabPercentageInactive = "_5j-8 _5j-6";
export var carrierTabWinnable = "_5j-9";
export var carrierTabWinnableActive = "_5j-a _5j-9";
export var carrierTabWinnableInactive = "_5j-b _5j-9";
export var comparisonContainer = "_5j-d";
export var missingRateButton = "_5j-n";
export var missingRateButtonActive = "_5j-o _5j-n";
export var missingRateButtonInactive = "_5j-p _5j-n";
export var missingRateButtonLabel = "_5j-q";
export var missingRateButtonLabelActive = "_5j-r _5j-q";
export var missingRateButtonLabelInactive = "_5j-s _5j-q";
export var sidebar = "_5j-c";
export var strategyButton = "_5j-e";
export var strategyButtonActive = "_5j-f _5j-e";
export var strategyButtonDescription = "_5j-k";
export var strategyButtonDescriptionActive = "_5j-l _5j-k";
export var strategyButtonDescriptionInactive = "_5j-m _5j-k";
export var strategyButtonInactive = "_5j-g _5j-e";
export var strategyButtonLabel = "_5j-h";
export var strategyButtonLabelActive = "_5j-i _5j-h";
export var strategyButtonLabelInactive = "_5j-j _5j-h";
export var unitToggleButton = "_5j-t";
export var unitToggleButtonActive = "_5j-u _5j-t";
export var unitToggleButtonInactive = "_5j-v _5j-t";
export var unitToggleButtonLabel = "_5j-w";
export var unitToggleButtonLabelActive = "_5j-x _5j-w";
export var unitToggleButtonLabelInactive = "_5j-y _5j-w";